import { createFileRoute } from '@tanstack/react-router'
import { CompletedChallengesPage } from '../../components'

export const Route = createFileRoute('/challenges/completed')({
  component: () => <CompletedChallengesPage />,
})
